import { NotificationService, TokenProvider, ITelemetryNamespaceLogger } from '@fluidx/office-fluid-types';
import { NamespaceLoggerAdapter } from '@fluidx/utilities';

export interface NotificationServiceForSharepointProps {
  /** A token provider that can return Sharepoint access tokens */
  tokenProvider: TokenProvider;
  /** The file/item ID of the underlying Sharepoint file */
  // TODO: Task 5057259 Remove back compat from SharepointShareService - itemId/fileId
  // When doing this work, replace fileId with itemId.
  fileId: string;
  /** The drive ID of the underlying Sharepoint file */
  driveId: string;
  /** The site URL of the underlying Sharepoint file */
  siteUrl: string;
  /** An optional logger for telemetry */
  logger?: ITelemetryNamespaceLogger;
  /** A correlation ID for Sharepoint API requests */
  correlationId?: string;
  /** Tenant which stores he file. If not specified then defaults to tenancy of current user */
  tenantId?: string;
}

/**
 * A helper method that returns an implementation of NotificationService for containers backed by Sharepoint.
 * @param props The parameters required to instantiate the implementation
 */
export function getNotificationServiceForSharepoint(
  props: NotificationServiceForSharepointProps
): Promise<NotificationService> {
  return import('./SharepointNotificationService').then((m) => {
    return new m.SharepointNotificationService({
      ...props,
      logger: props.logger ? new NamespaceLoggerAdapter('NotificationService', props.logger) : undefined
    });
  });
}
